// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-blue-haven -> weidner-apartment-homes-theme-blue-haven -> fitzroy-grove
// Generated: 2026-08-26T18:20:34.735Z
// Counts: 3 design, 28 content, 19 slot group, 0 collection binding, 8 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.secondary": {
    "cssVariable": "--vibe-color-secondary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Fitzroy Grove brings comfort home with a mix of in-home luxuries and vibrant community spaces. Every apartment features elegant details like designer cabinetry and backsplashes, while your community surrounds you with spaces to relax, play, and connect. Lounge poolside under a cabana, grill and chill outdoors, or join neighbors in the clubhouse. For pet lovers, there’s a bark park and a grooming area. Enjoy peace of mind with private garages, a secure package center, and more.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for <br>Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Live steps from the action at Fitzroy Grove in Rogers, AR. With S Fitzroy Place and I-49 nearby, you’re connected to Pinnacle Hills Promenade for shopping, the Walmart AMP for live music, and nature trails for biking or hiking. Wander Rogers’ downtown for boutique shopping and local bites, or head to Bentonville or Fayetteville for more adventures. Major employers like Walmart and Tyson Foods are minutes away. For outdoor enthusiasts, Hobbs State Park and area golf courses invite you to soak up Arkansas’ natural beauty.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Layout</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual stroll through Fitzroy Grove and discover what sets our Rogers, AR apartments apart. From spacious layouts to inviting lounge areas and pet-friendly walkways, you can picture yourself relaxing or hosting friends, all from your screen. Explore at your pace and get a sense for every detail before touring in person. Your next home is just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "future-residents-club-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>We don't just rent apartments. From the moment you walk through the front door you'll feel the comfort and serenity that makes our residents happy to call us home. Thoughtful amenities, well groomed grounds, and a dedicated staff all contribute to a higher standard of living. Whether you are waiting to move next year, or waiting for the perfect floor plan, we have a special program for you.</p><p>Join the Future Residents C﻿lub and reserve your spot now!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p>In-home and community amenities at Fitzroy Grove create a vibrant, inviting place to live in Rogers, AR. Enjoy designer kitchens, elegant touches, and those everyday conveniences that make life easy inside your apartment. Step outside to soak up the sun by the shimmering resort pool, play games on the putting green or bocce court, or gather friends for a grill in the community spaces. Even your pets have a place to run at the bark park. Every feature is crafted to help you relax, connect, and thrive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities designed for your lifestyle at Fitzroy Grove in Rogers, AR</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact the team at Fitzroy Grove in Rogers, AR</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach out to our friendly leasing team at Fitzroy Grove today. Whether you’re curious about available apartments, want to learn more about amenities, or would like to arrange a visit, our leasing team is here to help you with any questions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "discoveramenities.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Resort-Inspired Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplansintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Each floor plan at Fitzroy Grove is designed for the way you live. From studios with just the right amount of space to roomy three-bedroom homes built for entertaining, home office setups, or relaxing evenings in, every floor plan includes a chef-inspired kitchen with stainless steel appliances, in-home washer and dryer, abundant storage, and private patios or balconies. Take your pick, there’s a perfect layout waiting for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplansintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore floor plans at Fitzroy Grove in Rogers, AR</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p>In-home and community amenities at Fitzroy Grove create a vibrant, inviting place to live in Rogers, AR. Enjoy designer kitchens, elegant touches, and those everyday conveniences that make life easy inside your apartment. Step outside to soak up the sun by the shimmering resort pool, play games on the putting green or bocce court, or gather friends for a grill in the community spaces. Even your pets have a place to run at the bark park. Every feature is crafted to help you relax, connect, and thrive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodintro.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Fitzroy Grove places you in the heart of Rogers, AR, connected to everything that makes Northwest Arkansas shine. Pick up groceries or shop at Pinnacle Hills Promenade, grab a bite in downtown Rogers, or catch a show at the Walmart AMP. Nature lovers are close to parks, golf courses, and area trails, while commuters have easy access to I-49, Walmart, and Tyson Foods headquarters. Recreation, culture, and convenience blend beautifully in Rogers, Arkansas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Northwest Arkansas living in Rogers</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Rogers, AR, and Beyond</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for luxury apartments for rent in Rogers, AR? Fitzroy Grove places you close to the best of Northwest Arkansas, including Walmart and Tyson Foods headquarters, Pinnacle Hills Promenade, and Rogers' scenic parks. Choose from spacious studio, one-, two-, and three-bedroom floorplans with elegant touches and modern finishes. Each apartment welcomes you with a chef-inspired kitchen, in-home laundry, pantries, oversized closets, and plenty of room to unwind or entertain. The community is your playground, with spaces to lounge by the shimmering pool, play bocce, or let your pup roam the bark park. Here, comfort and convenience go hand in hand.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Fitzroy Grove</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Cozy and smartly designed, our studios make the most of every inch. Enjoy an open living area, a chef-inspired kitchen with designer cabinetry and granite countertops, an in-unit washer and dryer, and oversized windows. Ideal for those embracing simple living while enjoying all the modern perks. Plus, a patio or balcony brings peaceful Arkansas mornings right to you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Our one-bedroom floor plans offer comfort and versatility, whether you're working from home or love to host. Enjoy kitchen islands, fireplaces, abundant closet space, and private outdoor space. Elegant touches and open layouts give your days a peaceful, easy flow.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "VALUE",
    "customValue": "<p>With extra space for hobbies or guests, our two-bedroom apartments provide flexible living. Every home features garden tubs, tall ceilings, and built-in USB Ports. Entertaining or relaxing is all on your schedule here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel4_body": {
    "overrideType": "VALUE",
    "customValue": "<p>Spacious three-bedroom homes offer room for households of all kinds. Enjoy generous living areas, oversized closets, private outdoor retreats, and a layout that balances privacy and togetherness. All feature in-home laundry and upgraded finishes for an effortless lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Fitzroy Grove Virtually</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "pet-policy-hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019ff64a-2122-71af-94e2-9937f73399cc.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman petting a small dog on a cozy couch, enjoying a relaxing moment at home."
      }
    }
  },
  "amenitiesfeatures.apartmentBannerImage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f492-75fd-825b-28dfffb3dbbc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept kitchen and living room with dining area in a Fitzroy Grove apartment home"
      }
    }
  },
  "amenitiesfeatures.communityBannerImage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-d811-70ce-a4d4-3a4afbfe5dff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious resident clubroom with lounge seating at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitiesintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c9fa-756d-94bc-91389b24cbfe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio with lounge chairs and a fire pit at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitieslist.card0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Flex. Now Accepted — Move in now, pay over time or split your rent into smaller payments"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ddd4-70cc-9687-d431ad2dd2b4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Welcoming lobby and reception area at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitieslist.card1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Resort‑Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c6e4-7782-b318-c92c328f9014.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with the community building behind it at Fitzroy Grove"
      }
    }
  },
  "amenitieslist.card2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Private Poolside Cabanas"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ca05-73fb-af03-77a2fc97225a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pool deck and building exterior at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitieslist.card3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Putting Green"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c927-7796-9eea-12b20e2dbb4e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Landscaped putting green in front of the building at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitieslist.card4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Recreational Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-eb1a-729d-9069-7b9313156914.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Recreational lounge with comfortable seating and a TV at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitieslist.card5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Business Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-d820-75d7-91f0-796e5b5f355a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community room with work-friendly seating at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitieslist.card6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Java Bar"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-da8d-74d8-8cc7-0c509f2c3dad.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Coffee bar lounge with seating at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "amenitieslist.card7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "24‑Hour Health Club"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e607-715a-af5f-1b6e0098aa4c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "24-hour fitness center with strength and cardio equipment at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "discoveramenities.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e935-768b-a20b-7be9a807e527.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with strength and cardio equipment at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "fullbleedstripe.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c927-7796-9eea-12b20e2dbb4e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitzroy Grove community building with a putting green out front in Rogers, AR"
      }
    }
  },
  "propertyoverview.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c6e4-7782-b318-c92c328f9014.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with the apartment building in the background at Fitzroy Grove"
      }
    }
  },
  "tabbedcallouts.panel1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ead0-73e8-84a5-98cbdb114132.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Thumbnail 25 of 35 - Kitchen And Living Area at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "tabbedcallouts.panel2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f492-75fd-825b-28dfffb3dbbc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Thumbnail 30 of 35 - an open kitchen and living room area with a dining table at Fitzroy Grove, Rogers, AR"
      }
    }
  },
  "tabbedcallouts.panel3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f624-704e-9659-a592b6e05c2c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Thumbnail 32 of 35 - Spacious Bedroom at Fitzroy Grove, Rogers, 72758"
      }
    }
  },
  "tabbedcallouts.panel4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f00f-70ce-8eb6-3397d7b170b9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Thumbnail 26 of 35 - Kitchen And Living Room View at Fitzroy Grove, Rogers, AR"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
